import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="engage--announcement"
// Manages the announcement modal lifecycle — start, complete, dismiss.
export default class extends Controller {
  static targets = ["modal"]
  static values = {
    flowId: String,
    dismissible: { type: Boolean, default: true },
  }

  #abortController = null

  connect() {
    this.#abortController = new AbortController()
    void this.#startFlow()
  }

  disconnect() {
    this.#abortController?.abort()
  }

  async complete() {
    const stepKey = this.element.dataset.stepKey
    if (stepKey) {
      await this.#patch(
        `/api/v1/engage/flow_states/${this.flowIdValue}/complete_step`,
        {
          step_key: stepKey,
        },
      )
    }
    this.#remove()
  }

  async dismiss() {
    if (!this.dismissibleValue) return
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/dismiss`)
    this.#remove()
  }

  // ── Private ──────────────────────────────────────────────────────────────

  async #startFlow() {
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/start`)
  }

  #remove() {
    this.element.remove()
  }

  async #patch(url, body = null) {
    try {
      const options = { credentials: "include", responseKind: "json" }
      if (this.#abortController) options.signal = this.#abortController.signal
      if (body) options.body = body
      const response = await patch(url, options)
      if (!response.ok)
        console.error(`[Engage] API error ${response.statusCode}`, url)
      return response
    } catch (e) {
      if (e.name !== "AbortError") throw e
    }
  }
}
